var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-100px text-center bg-hex-$portalPrimaryColor flex items-center justify-center"},[_c('div',{staticClass:"h-48px text-hex-fff"},[_c('div',{staticClass:"whitespace-pre-wrap"},[_vm._v(_vm._s(_vm.statement))])])])}
var staticRenderFns = []

export { render, staticRenderFns }